import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Keeps the pre-order notice in sync on variant change.
 *
 * Same-product variant changes don't re-render the buy-buttons block — the
 * theme morphs only the variant picker and product-form patches its button
 * from the fetched fragment (see product-form.js #onVariantUpdate). With
 * variant-scoped release waves the notice differs per variant, so it needs
 * the same treatment: morph this element from its counterpart in the
 * fragment. The wrapper always renders (empty when the selected variant has
 * no pending wave) so the swap works in both directions.
 */
class PreorderNoticeComponent extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const target = this.closest('.shopify-section, dialog, product-card');
    target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  /** @param {CustomEvent} event */
  #onVariantUpdate = (event) => {
    const next = event.detail?.data?.html?.querySelector?.(
      `preorder-notice-component[data-block-id="${this.dataset.blockId}"]`
    );
    if (next) morph(this, next);
  };
}

if (!customElements.get('preorder-notice-component')) {
  customElements.define('preorder-notice-component', PreorderNoticeComponent);
}
